import * as React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { experimentalStyled as styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const useStyles = makeStyles({
  tabs_header: {
    borderRadius: "25px",
    backgroundColor: "#1976d2",
    color: "white",
    width: "fit-content",
    margin: "auto",
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const skills = [
  {
    name: "HTML",
    icon: "html5",
  },
  {
    name: "CSS",
    icon: "css3-alt",
  },
  {
    name: "JavaScript",
    icon: "js-square",
  },
  {
    name: "Bootstrap",
    icon: "bootstrap",
  },
  {
    name: "Material UI",
    icon: "",
  },
  {
    name: "Angular",
    icon: "angular",
  },
  {
    name: "React",
    icon: "react",
  },
  {
    name: "TypeScript",
    icon: "js",
  },
  {
    name: "Jest",
    icon: "",
  },
  {
    name: "SASS (scss)",
    icon: "sass",
  },
  {
    name: "Gulp",
    icon: "gulp",
  },
  {
    name: "Command Prompt",
    icon: "terminal",
  },
  {
    name: "Firebase 9 ",
    icon: "",
  },
  {
    name: "MongoDB",
    icon: "database",
  },
  {
    name: "Node.js",
    icon: "",
  },
];

export default function SkillsTabsComp() {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <Box sx={{ bgcolor: "background.paper", width: "100%" }}>
      <AppBar position="static" className={classes.tabs_header}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
          centered
          sx={{ borderRadius: "25px" }}
          className="theTabs"
        >
          <Tab label="Techs" {...a11yProps(0)} />
          <Tab label="Tools" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {skills.map((skill, index) => (
              <Grid item xs={2} sm={4} md={4} key={index}>
                <Item>
                  <i className={`fab fa-${skill.icon} fa-lg`}></i>
                  {skill.icon === "terminal" && (
                    <i className={`fas fa-${skill.icon} fa-lg`}></i>
                  )}
                  <Typography sx={{ fontWeight: "bold" }}>
                    {skill.name}
                  </Typography>
                </Item>
              </Grid>
            ))}
          </Grid>
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {["Visual Studio Code", "GitHub", "Postman", "Cmder"].map(
              (tool, index) => (
                <Grid item xs={2} sm={4} md={4} key={index}>
                  <Item>
                    <Typography sx={{ fontWeight: "bold" }}>{tool}</Typography>
                  </Item>
                </Grid>
              )
            )}
          </Grid>
        </TabPanel>
      </SwipeableViews>
    </Box>
  );
}
